import React, {useEffect} from "react"
import ReactJson from "react-json-view"
import {connect} from "react-redux"
import Styles from "./index.less"

const JsonViewer = (props: any) => {
    return (
        <div className={Styles["jsonBody"]}>
            <ReactJson
                name={false}
                style={{
                    fontSize: "12px",
                    fontFamily: "auto",
                }}
                indentWidth={8}
                displayObjectSize={false}
                displayDataTypes={false}
                collapsed={4}
                collapseStringsAfterLength={80}
                src={props.jsonData}
            />
        </div>
    )
}

export default connect((state: any) => {
    return {
        jsonData: state.jsonData,
    }
})(JsonViewer)
